<template>
    <div>
        
        <div class="app-content content devcontent ">
            <div class="content-overlay"></div>
            <div class="header-navbar-shadow"></div>
            <div class="content-wrapper">
                <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                    <div class="container-fluid">
                       <div class="row breadcrumbs-top">
                          <div class="col-md-12 content-header-left px-0">
                            <h3 class="content-header-title float-left mb-0" > Calling Dashboard </h3>
                            <div class="breadcrumb-wrapper">
                                <ol class="breadcrumb">
                                    <!-- <li class="breadcrumb-item"><router-link to='/mydashboard'> Dashboard</router-link>
                                    </li> -->
                                    
                                   
                                    
                                </ol>
                            </div>
                            
                          </div>
                       </div>
                    </div>
                    
                </div>
                <div class="content-body">
                   
                    <section>
                         <div class="card">
                          
                            <div class="card-header px-0  common_top_title_searchbgst_dock">
                                <div class="container-fluid " >
                                    <div class="row row fc_my-05">
                                        <div class="w-auto px-1 mobile-padding-0-2">
                                            <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                                <div class="avatar-content">
                                                    <i  class="i_icon_st la-chalkboard-teacher las lab font-medium-5 "></i>
                                                </div>
                                            </div>
                                            <h4 class="card-title d-inline-flex ml-0 mb-0"> Calling Dashboard</h4>
                                        </div>
                                       
                                    </div>    
                                        
                                </div>
                            </div>
                          
                          
                                <div class="card text-center mb-1 p-1 p-md-2">
                                    <div class="row match-height gateperformanceiconTrakingdb">
                                        <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                            <div class="card text-center my_projects-bgs_co performance_projects-bgs-15 mb-1" >
                                                <div class="gateperformanceicon">
                                                    <div class="avatar bg-light-warning p-50 mb-1">
                                                        <div class="avatar-content avatar_iconsview">
                                                            <em class="las la-phone custom-class font-medium-10"></em>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                                   <div class="timeGatetimeview">
                                                    <span class="avgGatetimeview"> {{dataPoints.TotalCalls}}</span>
                                                    </div>
                                                    <h2 class="font-weight-bolder">Total Calls </h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                            <div class="card text-center my_projects-bgs_co performance_projects-bgs-16 mb-1" >
                                                <div class="gateperformanceicon">
                                                    <div class="avatar bg-light-warning p-50 mb-1">
                                                        <div class="avatar-content avatar_iconsview">
                                                            <em class="las la-phone custom-class font-medium-10"></em>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                                   <div class="timeGatetimeview">
                                                    <span class="avgGatetimeview">{{dataPoints.DelayedEsc}}</span>
                                                    </div>
                                                    <h2 class="font-weight-bolder">Delay Calls </h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                            <div class="card text-center my_projects-bgs_co performance_projects-bgs-17 mb-1" >
                                                <div class="gateperformanceicon">
                                                    <div class="avatar bg-light-warning p-50 mb-1">
                                                        <div class="avatar-content avatar_iconsview">
                                                            <em class="las la-phone custom-class font-medium-10"></em>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                                   <div class="timeGatetimeview">
                                                    <span class="avgGatetimeview"> {{dataPoints.IdleWait}}</span>
                                                    </div>
                                                    <h2 class="font-weight-bolder">Idle Calls  </h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                            <div class="card text-center my_projects-bgs_co performance_projects-bgs-18 mb-1" >
                                                <div class="gateperformanceicon">
                                                    <div class="avatar bg-light-warning p-50 mb-1">
                                                        <div class="avatar-content avatar_iconsview">
                                                            <em class="las la-phone custom-class font-medium-10"></em>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                                   <div class="timeGatetimeview">
                                                    <span class="avgGatetimeview"> 0</span>
                                                    </div>
                                                    <h2 class="font-weight-bolder">Stop Calls  </h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                            <div class="card text-center my_projects-bgs_co performance_projects-bgs-19 mb-1" >
                                                <div class="gateperformanceicon">
                                                    <div class="avatar bg-light-warning p-50 mb-1">
                                                        <div class="avatar-content avatar_iconsview">
                                                            <em class="las la-phone custom-class font-medium-10"></em>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                                   <div class="timeGatetimeview">
                                                    <span class="avgGatetimeview">{{dataPoints.AccedentCalls}}</span>
                                                    </div>
                                                    <h2 class="font-weight-bolder">Accident Calls  </h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                            <div class="card text-center my_projects-bgs_co performance_projects-bgs-20 mb-1" >
                                                <div class="gateperformanceicon">
                                                    <div class="avatar bg-light-warning p-50 mb-1">
                                                        <div class="avatar-content avatar_iconsview">
                                                            <em class="las la-phone custom-class font-medium-10"></em>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                                   <div class="timeGatetimeview">
                                                    <span class="avgGatetimeview"> {{dataPoints.BreakDown}}</span>
                                                    </div>
                                                    <h2 class="font-weight-bolder">Brakedown Calls </h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                         </div>
                    </section>
                </div>

                <section>
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header px-0  common_top_title_searchbgst_dock">
                                        <div class="container-fluid " >
                                            <div class="row row fc_my-05">
                                                <div class="w-auto px-1 mobile-padding-0-2">
                                                    <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                                        <div class="avatar-content">
                                                            <i  class="i_icon_st la-phone las lab font-medium-5 "></i>
                                                        </div>
                                                    </div>
                                                    <h4 class="card-title d-inline-flex ml-0 mb-0"> Calling Details</h4>
                                                </div>
                                            
                                            </div>    
                                                
                                        </div>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-body card-dashboard">
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Sr. No</th>
                                                            <th>Vehicle Details</th>
                                                            <th>Driver Details</th>
                                                            <th>Trip ID</th>
                                                            <th>Call Details</th>
                                                            <th>Call Timing Details</th>
                                                            <th>Call Recording</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(data, idx) in dataList">
                                                            <tr>
                                                            <td data-column="Subject" > {{idx + 1}}</td>
                                                            <td data-column="Vehical Details">
                                                                <span style="font-weight: bold; font-size: smaller;">Vehical No:</span> <br>
                                                                <span style="font-size: smaller;">{{ data.Vechileno }}</span> <br>
                                                                <span style="font-weight: bold; font-size: smaller;">Vehical Info:</span> <br>
                                                                <span style="font-size: smaller;">{{ data.Vehicledetails }}</span>
                                                            </td>
                                                            <td data-column="Driver Details">
                                                                <span style="font-weight: bold; font-size: smaller;">Name:</span> <br>
                                                                <span style="font-size: smaller;">{{ data.DriverName }}</span> <br>
                                                                <span style="font-weight: bold; font-size: smaller;">Mobile No.:</span> <br>
                                                                <span style="font-size: smaller;">{{ data.DriverMobile }}</span>
                                                            </td>
                                                            <td data-column="Priority"> {{data.TripId}}</td>
                                                            <td data-column="call Details">
                                                                <span style="font-weight: bold; font-size: smaller;">Call Reason:</span> <br>
                                                                <span style="font-size: smaller;">{{ data.CallReason }}</span> <br>
                                                                <span style="font-weight: bold; font-size: smaller;">Calling Time:</span> <br>
                                                                <span style="font-size: smaller;">{{ data.CallTime }}</span>
                                                            </td>
                                                            <td data-column="call timing Details text-nowrap">
                                                                <span style="font-weight: bold; font-size: smaller;">Call Start Time:</span>
                                                                <span style="font-size: smaller; display: inline-block;">{{ data.CallStartTime }}</span>
                                                                <br>
                                                                <span style="font-weight: bold; font-size: smaller;">Call End Time:</span>
                                                                <span style="font-size: smaller; display: inline-block;">{{ data.CallEndTime }}</span>
                                                                <br>
                                                                <span style="font-weight: bold; font-size: smaller;">Duration: </span>
                                                                <span style="font-size: smaller; display: inline-block;">{{ calculateDuration(data.CallStartTime, data.CallEndTime) }} hrs</span>
                                                            </td>

                                                            <td data-column="Priority">
                                                                <div style="display: flex; align-items: center;">
                                                                    <!-- <a >{{ data.url }}</a> -->
                                                                    <a :href="data.url" download target="_blank" style="margin-left: 20px;">
                                                                        <i class="las la-download custom-class" style="font-weight: bold; font-size: 20px;"></i>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    </div>
    
    </template>
    
    <script>
    import axios from "axios"
    import moment from "moment";
    import Pagination from 'vue-pagination-2'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css'
    import Treeselect from '@riophae/vue-treeselect'
    import VueElementLoading from 'vue-element-loading'
    import { XCircleIcon, FileIcon, UploadIcon, DownloadIcon, EditIcon } from 'vue-feather-icons';
    import CONSTANT from "../constants.js"
    import { read, utils } from "xlsx";
    import schema from "../utils/schema";
    import common_methods from "../utils/common_methods"
    import searchMasterNameList from "../utils/searchMasterNameList"
    
    export default({
        name:'trackingDashboard',
        mixins: [ common_methods, searchMasterNameList ],
        components: {
            Treeselect,
            DatePicker,
            VueElementLoading,
            Pagination,
            UploadIcon,
            FileIcon,
            XCircleIcon,
            DownloadIcon,
            EditIcon,
            Pagination,
        },
        data() {
            return {
                un:'',
                isLoading: false,
                isShipmentsSyncing: false,
                isMasterListLoading: true,
                pagefeatures:[],
                isFormEdit: false,
                warehouse_master: false,  
    
                master: {
                   
                    warehouse_master: {
                        url: "/master/warehouses",
                        list: [],
                        totalcount: 0,
                        pageCount: 0,
                        page: 1,
                        pagelimit: CONSTANT.LIMIT,
                        currPageNum: 0,
                        pageoffset: 1,
                        presignedUrls: [],
                    },
    
                 
                },
                dataPoints: {
                    AccedentCalls: 0,
                    BreakDown: 0,
                    DelayedEsc:0,
                    DestinationReach:0,
                    DockWaitTime:0,
                    GateWaitTime:0,
                    IdleWait:0,
                    LoadUnloadwait:0,
                    MultiReach:0,
                    TotalCalls:0,
                    VehicleScheduled:0
                },
                dataList:[],          
                photoCaptureSound: 'sound/iphone-camera-capture-6448.wav',
            }  
        } ,
        mounted(){
          
            this.getCallingDashboardCounts()
    
            
        },
        methods: {
           
         
            toggleMasterCreate() {
                if(this.isFormEdit) {
                    this.resetform('warehouse_master')
                }
                this.isFormEdit = false
                this.warehouse_master = !this.warehouse_master; 
            },
    
            getCallingDashboardCounts() {
                this.isLoading = true
                this.makeRequest("POST", "/stats/callingdashboard-data-points")
                    .then(result => {
                        this.isLoading = false
                        this.dataPoints = result.data.data.totalcalldetails[0]
                        this.dataList = result.data.data.calldetails
                    })
                    .catch(e => {
                        this.displayError(e)
                    })
            },
            calculateDuration(startTime, endTime) {
                const start = new Date(startTime);
                const end = new Date(endTime);
                const durationInSeconds = (end - start) / 1000;
                const hours = Math.floor(durationInSeconds / 3600);
                const minutes = Math.floor((durationInSeconds % 3600) / 60);
                const seconds = Math.floor(durationInSeconds % 60);
                return `${hours}:${minutes}:${seconds}`;
            }
    
        }
    })
    </script>
    <style scoped>
        .alignment{
            margin-left: 20px;
            margin-bottom: 20px;
        }
        .requiredField {
            margin-left: 2px;
            color: red
        }
        #overlay-camera {
          position: fixed;
          display: none;
          width: 100%; 
          height: 100%; 
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0,0,0,1);
          z-index: 2; 
          cursor: pointer;
        }
        
        .overlay-camera {
          position: fixed;
          display: none;
          width: 100%; 
          height: 100%; 
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0,0,0,1);
          z-index: 2; 
          cursor: pointer;
        }

        </style>